
<span
  ref="atoms__tooltip"
  class="atom__tooltip"
  :class="[this.targetSelf ? 'inline-block' : 'hidden']"
>
  <slot></slot>
</span>
